import React from 'react';

import iconDownload from 'img/icon-download.svg';
import iconXml from 'img/icon-xml.svg';

import Text from 'components/Text';
import ModelButton from 'components/ModelButton';
import { eventName, notaFiscalAction } from 'components/ApplicationInsights/eventNames';

import { CTeState } from 'models/CTEs';
import { IDownloadTypes } from 'models/Order';

import DownloadService from 'services/download.service';
import { ITableModel } from '../../interface';

const _downloadService = new DownloadService();

const billedFilter = {
  billingDate: { ne: null },
  items: { any: { orderItemStatusType: { eq: 'PERFORMED' } } },
};

const invoiceActionButton = (title?: string, size?: number) =>
  ModelButton(
    title || '',
    iconDownload,
    (data: CTeState) =>
      _downloadService.OpenFileFromCTE(IDownloadTypes.ELECTRONIC_BILL_LADING, data),
    eventName.DOWNLOAD_CTE,
    size,
    window.location.pathname === '/cte' ?
      notaFiscalAction.CTE_NOTAFISCAL_PDF :
      notaFiscalAction.DASHBOARD_NOTAFISCAL_CTE
  );

const xmlActionButton = (title?: string, size?: number) =>
  ModelButton(
    title || '',
    iconXml,
    (data: CTeState) =>
      _downloadService.OpenFileFromCTE(IDownloadTypes.ELECTRONIC_BILL_LADING_XML, data),
    eventName.XML_CTE,
    size,
    window.location.pathname === '/cte' ?
      notaFiscalAction.CTE_NOTAFISCAL_XML :
      notaFiscalAction.DASHBOARD_NOTAFISCAL_CTE_XML
  );

const labelNumberCte = {
  label: 'N° CT-e',
  key: 'documentEbl',
  size: 115,
  maxSize: 115,
  Component: (data: CTeState) => (
    <Text size={12} className="color-blue-gray text-wrap">
      {data.documentEbl || ''}
      /
      {data.serialNumber || ''}
    </Text>
  ),
};

const labelSubsidiary = {
  label: 'Filial',
  key: 'subsidiaryName',
  size: 205
};

const labelSender = {
  label: 'Remetente',
  key: 'senderCustomerName',
  noFilter: true,
  size: 205,
  maxSize: 205,
};

const labelReceiver = {
  label: 'Destinatário',
  key: 'recipientCustomerName',
  noFilter: true,
  size: 205,
  maxSize: 205,
};

const labelPayer = {
  label: 'Pagador',
  key: 'payerCustomerName',
  noFilter: true,
  size: 205,
  maxSize: 205,
};

const labelTypeOfFreight = {
  label: 'Tipo de frete',
  key: 'freightType',
  size: 90,
  maxSize: 90
};

const labelDateOfIssue = {
  label: 'Data da Emissão',
  key: 'issueDate',
  type: 'date',
  size: 100,
  maxSize: 100,
};

const labelValue = {
  label: 'Valor',
  key: 'freightCost',
  type: 'currency',
  size: 150,
  maxSize: 150,
};

const cteModel: Array<ITableModel> = [
  labelNumberCte,
  labelSubsidiary,
  labelSender,
  labelReceiver,
  labelPayer,
  labelTypeOfFreight,
  labelDateOfIssue,
  labelValue,
];

const cteModelComplete = () => {
  const model: Array<ITableModel> = [
    ...cteModel,
    invoiceActionButton(),
    xmlActionButton()
  ];

  return model;
};

const cteModelTableOpenProtocol = () => {
  const model: Array<ITableModel> = [
    ...cteModel
  ];

  return model;
};

const cteModelSliderInvoice: Array<ITableModel> = [
  { ...labelNumberCte, size: 150, maxSize: 150 },
  { ...labelSubsidiary, size: 250 },
  { ...labelSender, size: 150, maxSize: 150 },
  { ...labelDateOfIssue, size: 150, maxSize: 150 },
  { ...labelValue, size: 120, maxSize: 120 }
];

const cteModelDownloadSliderInvoice: Array<ITableModel> = [
  ...cteModelSliderInvoice,
  invoiceActionButton("CT-e", 80)
];

const cteModelDownloadXmlSliderInvoice: Array<ITableModel> = [
  ...cteModelSliderInvoice,
  xmlActionButton("XML", 80)
];

const fastFilters = [
  { label: 'Mais recentes', value: 'desc' },
  { label: 'Mais antigos', value: 'asc' },
];

export {
  cteModelComplete,
  billedFilter,
  cteModelDownloadSliderInvoice,
  cteModelDownloadXmlSliderInvoice,
  cteModelTableOpenProtocol,
  fastFilters
};